import { sumAmounts } from '../money';

type Row = { amountDue: string; daysOverdue: number; publiclyListed: boolean };

/**
 * Who is late, from arqam's arrears list: a member is late once a bill is
 * past its due date (`daysOverdue > 0`, a bill's «متأخرة» status); members who
 * owe but aren't late yet are left out. The amount is a display sum of
 * arqam's figures, in centimes.
 */
export function latePayersSummary(rows: Row[]) {
  const late = rows.filter((r) => r.daysOverdue > 0);
  return {
    lateCount: late.length,
    lateAmount: sumAmounts(late.map((r) => r.amountDue)),
    publicCount: late.filter((r) => r.publiclyListed).length,
  };
}
